var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareDevelopment19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.2,
    cy: 46.2,
    r: 46.2,
    fill: "#EAE3FF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEAAFC",
    fillRule: "nonzero",
    stroke: "#BEAAFC",
    strokeWidth: 0.5,
    d: "M65.05 52.5v-.866c-.003-1.87-1.512-3.384-3.375-3.386H46.198l1.09-12.036c.017-.178-.043-.355-.163-.488-.121-.132-.292-.207-.47-.206h-8.247v-4.455h2.538c.35 0 .634-.285.634-.637V27.88c0-.351-.284-.636-.634-.636h-5.71c-.35 0-.634.285-.634.636v7.638h-6.977c-.181 0-.353.077-.474.213-.12.135-.177.315-.157.495l3.172 28.006c.036.321.308.564.63.564h13.321c.088-.001.174-.021.254-.059.192.037.388.057.583.06h16.721c1.863-.003 3.372-1.518 3.375-3.387v-.866c-.004-1.292-.743-2.47-1.903-3.032v-1.98c1.16-.562 1.899-1.74 1.903-3.033zm-1.269-.866v.865c0 1.167-.943 2.112-2.106 2.113h-16.72c-1.163 0-2.105-.946-2.107-2.113v-.865c.002-1.167.944-2.112 2.106-2.113h16.721c1.163 0 2.105.946 2.106 2.113zm-27.91-23.117h4.44v1.273h-2.537c-.35 0-.634.285-.634.636v5.092h-1.27v-7.001zm-7.536 8.274H45.96l-1.04 11.46c-1.848.02-3.337 1.528-3.34 3.383v.865c.003 1.033.479 2.007 1.29 2.642-.01.036-.018.072-.022.108v2.546c.004.036.012.072.022.107-.811.636-1.287 1.61-1.29 2.642v.866c.004.771.273 1.518.761 2.113H31.363l-3.028-26.732zm35.446 23.753v.866c0 1.167-.943 2.112-2.106 2.113h-16.72c-1.163 0-2.105-.946-2.107-2.113v-.866c.002-1.166.944-2.112 2.106-2.113h16.721c1.163.001 2.105.947 2.106 2.113h0zm-1.903-4.659v1.273h-17.76v-1.273h17.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment19);
export default __webpack_public_path__ + "static/media/software-development19.177bca2b5fce1624c3cfb8a41218d3c3.svg";
export { ForwardRef as ReactComponent };